__turbopack_context__.v({
  "mobile": "PlaylistThumbnailGrid-module-scss-module__QDRuaq__mobile",
  "playlistThumbnailGrid": "PlaylistThumbnailGrid-module-scss-module__QDRuaq__playlistThumbnailGrid",
  "playlistThumbnailImage": "PlaylistThumbnailGrid-module-scss-module__QDRuaq__playlistThumbnailImage",
  "playlistThumbnailPrimary": "PlaylistThumbnailGrid-module-scss-module__QDRuaq__playlistThumbnailPrimary",
  "playlistThumbnailStack": "PlaylistThumbnailGrid-module-scss-module__QDRuaq__playlistThumbnailStack",
  "tiny": "PlaylistThumbnailGrid-module-scss-module__QDRuaq__tiny",
});
